import React, { useState, useEffect } from "react";
import { IMaskInput } from "react-imask";

function MaskInput(props) {
  const [value, setValue] = useState("");
  const { label, meta, mask, input } = props;
  const { touched, error, warning } = meta || {};

  useEffect(() => {
    if (input?.value) {
      setValue(input.value);
    }
  }, [input?.value]);

  const handleAccept = (val) => {
    setValue(val);

    // Transform phone number: if starts with 0, replace with 31 (Dutch country code)
    let transformedVal = val;
    if (mask && mask.includes("9") && transformedVal.startsWith("0")) {
      transformedVal = "31" + transformedVal.substring(1);
    }

    if (input?.onChange) {
      input.onChange(transformedVal);
    }
  };

  // Convert react-input-mask format to imask format
  // react-input-mask uses "9" for digits, imask uses "0"
  const convertMask = (maskStr) => {
    if (!maskStr) return "0000-0000-0000-0000";
    return maskStr.replace(/9/g, "0");
  };

  return (
    <div>
      <label>{label}</label>
      <div>
        <IMaskInput
          mask={convertMask(mask)}
          value={value}
          onAccept={handleAccept}
          placeholder={label}
          className="form-control"
          definitions={{
            "0": /[0-9]/,
          }}
        />
        {touched &&
          ((error && <span className="text-danger">{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    </div>
  );
}

export default MaskInput;
